import { Injectable, inject } from '@angular/core';
import { AuthService } from './auth.service';
import { interval, switchMap, tap } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SessionManagementService {
  private authService = inject(AuthService);

  constructor() {
    // Set up periodic token validation (every 5 minutes)
    interval(5 * 60 * 1000) // 5 minutes
      .pipe(
        switchMap(() => this.authService.checkAuthStatus())
      )
      .subscribe(isAuthenticated => {
        if (!isAuthenticated) {
          console.log('Session expired or invalid, user logged out');
        }
      });

    // Subscribe to auth state changes
    this.authService.authStatus$.subscribe(isAuthenticated => {
      if (!isAuthenticated) {
        console.log('User is no longer authenticated');
      } else {
        console.log('User is authenticated');
      }
    });
  }
}